<template>
    <div
        class="Tooltip"
    >
        {{ tooltip }}
        <span class="Tooltip__arrow"></span>
    </div>
</template>
<script>
export default {
    name: 'Tooltip',
    props: {
        tooltip: {
            type: String,
            required: true,
        },
    },
};
</script>
<style lang="scss">
    .Tooltip {
        color: $text-dark;
        text-align: center;
        position: absolute;
        min-width: 100%;
        background: $white;
        border-radius: 4px;
        padding: 0.5rem;
        bottom: calc(100% + 0.5rem);
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        border: 1px solid #D5DBE5;
        left: 50%;
        transform: translate(-50%, 0);

        &__arrow {
            background: $white;
            position: absolute;
            height: 0.6rem;
            width: 0.6rem;
            border-bottom: 1px solid $grey-100;
            border-right: 1px solid $grey-100;
            border-left: 1px solid $white;
            border-top: 1px solid $white;
            left:0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            bottom: -0.3rem;
            transform: rotate(45deg);
        }
    }
</style>
